import React, { useState } from 'react';
import { Button, Drawer, Flex } from 'antd';
import { LinkMeta } from 'db/types';
import { Link } from 'react-router-dom';

type DrawerButtonProps = {
    label: string,
    drawerTitle: string,
    items: LinkMeta[]
}
export const DrawerButton = (props: DrawerButtonProps) => {
	const [open, setOpen] = useState(false);

	const showDrawer = () => {
		setOpen(true);
	};

	const onClose = () => {
		setOpen(false);
	};

	return (
		<>
			<Button type="primary" shape='round' onClick={showDrawer} style={{ margin: "10px", fontWeight:500}}>
				{props.label}
			</Button>
			<Drawer title={props.drawerTitle} onClose={onClose} open={open}>
				<Flex vertical gap={30}>
					{props.items.map((elem, index) => <Link key={index} target={elem.target} to={elem.to} style={{fontWeight: 500}}>{elem.title}</Link>)}
				</Flex>
			</Drawer>
		</>
	);
};

